module.exports = __webpack_public_path__ + "static/media/download-ipm2-badge-light.44dfeee0.svg";